var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1161 13.3684C21.8512 20.1585 24.7368 22.2105 24.7368 22.2105H2C2 22.2105 5.78947 19.5158 5.78947 10.0842C5.78947 7.94014 6.58797 5.88389 8.0093 4.36781C9.43063 2.85172 11.3584 2 13.3684 2C13.7945 2 14.2169 2.03827 14.6316 2.11304",
    stroke: "url(#paint0_linear_404_1915)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2106 9.57895C24.3035 9.57895 26.0001 7.88234 26.0001 5.78947C26.0001 3.69661 24.3035 2 22.2106 2C20.1177 2 18.4211 3.69661 18.4211 5.78947C18.4211 7.88234 20.1177 9.57895 22.2106 9.57895Z",
    stroke: "url(#paint1_linear_404_1915)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5536 26C15.3316 26.3829 15.0129 26.7007 14.6293 26.9215C14.2458 27.1424 13.811 27.2587 13.3684 27.2587C12.9258 27.2587 12.491 27.1424 12.1075 26.9215C11.724 26.7007 11.4052 26.3829 11.1831 26",
    stroke: "url(#paint2_linear_404_1915)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_404_1915",
    x1: 13.3684,
    y1: 2,
    x2: 13.3684,
    y2: 22.2105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_404_1915",
    x1: 22.2106,
    y1: 2,
    x2: 22.2106,
    y2: 9.57895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_404_1915",
    x1: 13.3684,
    y1: 26,
    x2: 13.3684,
    y2: 27.2587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.24b8dd4ff0a80a0962f2dfe53e8e7b2c.svg";
export { ForwardRef as ReactComponent };